module.exports = __webpack_public_path__ + "img/details-left.5a0bf2d8.png";